import type { PayzheBtpStatusPayload } from './types';

/** Restart background service only when it is down or stuck in a failed lifecycle. */
export function shouldRestartPayzheBtpService(status: PayzheBtpStatusPayload): boolean {
  if (status.serviceLifecycle === 'failed') return true;
  if (status.serviceRunning === false && status.serviceLifecycle === 'stopped') return true;
  if (status.serviceRunning === false && !status.serviceLifecycle) return true;
  return false;
}
